/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './feature-section';
import '../content-block/content-block-heading';
import '../content-item/content-item-paragraph';
import '../image/index';
import '../card/index';
